import { render, staticRenderFns } from "./DrawerContent.vue?vue&type=template&id=512fe8f4&scoped=true&"
import script from "./DrawerContent.vue?vue&type=script&lang=js&"
export * from "./DrawerContent.vue?vue&type=script&lang=js&"
import style0 from "./DrawerContent.vue?vue&type=style&index=0&id=512fe8f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512fe8f4",
  null
  
)

export default component.exports